import {Component} from 'react';
import { ApplicationContext } from '@/app/context/AppContext';
import { Temas } from '@/app/constants/temas';

class SComponent extends Component {
    componentDidMount(){
        this.context.setTema(Temas.DEFAULT);
    }

    setTema(tema){
        this.context.setTema(tema);
    }
}
SComponent.contextType = ApplicationContext;
export default SComponent;